import { render, staticRenderFns } from "./TicketsErrors.vue?vue&type=template&id=2a8eeed8&"
import script from "./TicketsErrors.vue?vue&type=script&lang=js&"
export * from "./TicketsErrors.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports